import { useEffect } from "react";
import { Alignment, Fit, Layout, useRive, useStateMachineInput } from "@rive-app/react-canvas";

interface RiveNavIconProps {
    artboard: "Fire" | "Chat" | "Alert";
    inputName: "fire" | "chat" | "alert";
    active?: boolean;
}

export const RiveNavIcon = ({ artboard, inputName, active = false }: RiveNavIconProps) => {
    const { RiveComponent, rive } = useRive({
        src: "/assets/fire.riv",
        artboard,
        stateMachines: "State Machine 2",
        autoplay: true,
        layout: new Layout({
            fit: Fit.Contain,
            alignment: Alignment.Center,
        }),
    });
    const stateInput = useStateMachineInput(rive, "State Machine 2", inputName, active);

    useEffect(() => {
        if (stateInput) {
            stateInput.value = active;
        }
    }, [active, stateInput]);

    return (
        <span className="block h-6 w-6 max-md:h-[34px] max-md:w-[34px]">
            <RiveComponent
                aria-hidden="true"
                className="h-full w-full"
            />
        </span>
    );
};
